import { Control, FieldValues, Path, useController } from "react-hook-form";
import { MenuPlacement } from "react-select";
import styled from "styled-components";

import Tag, { TagsHolder } from "@/components/Tag";
import { Option, StyledSelect } from "../Dropdown";

const Select = styled(StyledSelect)`
  .react-select__control {
    cursor: pointer;
  }
`;

const StyledTagsHolder = styled(TagsHolder)`
  margin-top: 16px;
`;

interface Props<FormDataT extends FieldValues, OptionValueT> {
  disabled?: boolean;
  placeholder?: string;
  id?: string;
  options: Option<OptionValueT>[];
  control: Control<FormDataT>;
  name: Path<FormDataT>;
  menuPlacement?: MenuPlacement;
  label?: string;
}

const MultiselectField = <FormDataT extends FieldValues, OptionValueT>({
  disabled = false,
  placeholder = "Select",
  id,
  options,
  name,
  control,
  menuPlacement = "bottom",
}: Props<FormDataT, OptionValueT>) => {
  const {
    field: { onChange, onBlur, value: values },
    fieldState: { error },
  } = useController({ name, control });

  const onSelectChange = (val: OptionValueT) => {
    onChange([...values, val]);
  };

  const onRemoveValue = (removableValue: OptionValueT) => {
    onChange(values.filter((val: OptionValueT) => val !== removableValue));
  };

  const filteredOptions = options.filter(
    (option) => !values.includes(option.value)
  );

  return (
    <>
      <Select
        $hasError={!!error}
        classNamePrefix="react-select"
        isDisabled={disabled}
        options={filteredOptions}
        isMulti
        onChange={(options) =>
          onSelectChange((options as Option<OptionValueT>[])[0].value)
        }
        value={[]}
        id={id}
        onBlur={onBlur}
        menuPlacement={menuPlacement}
        placeholder={placeholder}
      />
      {!!(values as Array<OptionValueT>)?.length && (
        <StyledTagsHolder>
          {values.map((value: OptionValueT, index: number) => (
            <Tag key={index} onDelete={() => onRemoveValue(value)}>
              {options.find((opt) => opt.value === value)?.label}
            </Tag>
          ))}
        </StyledTagsHolder>
      )}
    </>
  );
};

export default MultiselectField;
